export default __webpack_public_path__ + "static/article-tech-savvy-savers-dc8d13b4683432b34093d0fa901366fd.jpg";